import theme from '../../theme';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

export const handleColorSystem = (media) => {
  let colorSystem;
  let mainColor;
  let lightColor;
  let darkColor;
  let w01Color;

  switch (media) {
    case 'FACEBOOK':
      colorSystem = 'facebook';
      mainColor = theme.palette.facebook.main;
      lightColor = theme.palette.facebook.light;
      darkColor = theme.palette.facebook.dark;
      w01Color = theme.palette.facebook.facebook01;
      break;
    case 'GOOGLE':
      colorSystem = 'google';
      mainColor = theme.palette.google.main;
      lightColor = theme.palette.google.light;
      darkColor = theme.palette.google.dark;
      w01Color = theme.palette.google.google01;
      break;
    case 'LINE':
      colorSystem = 'line';
      mainColor = theme.palette.line.main;
      lightColor = theme.palette.line.light;
      darkColor = theme.palette.line.dark;
      w01Color = theme.palette.line.line01;
      break;
    case 'TABOOLA':
      colorSystem = 'taboola';
      mainColor = theme.palette.taboola.main;
      lightColor = theme.palette.taboola.light;
      darkColor = theme.palette.taboola.dark;
      w01Color = theme.palette.taboola.taboola01;
      break;
    case 'SYSTEM':
      colorSystem = 'system';
      mainColor = theme.palette.system.main;
      lightColor = theme.palette.system.light;
      darkColor = theme.palette.system.dark;
      w01Color = theme.palette.system.w0;
      break;
    default:
      colorSystem = 'system';
      mainColor = theme.palette.system.main;
      lightColor = theme.palette.system.light;
      darkColor = theme.palette.system.dark;
      w01Color = theme.palette.system.w0;
      break;
  }
  return {
    colorSystem,
    mainColor,
    lightColor,
    darkColor,
    w01Color
  };
}

export const colorPalette = {
  facebook: {
    main: theme.palette.facebook.main,
    light: theme.palette.facebook.light,
    dark: theme.palette.facebook.dark
  },
  google: {
    main: theme.palette.google.main,
    light: theme.palette.google.light,
    dark: theme.palette.google.dark
  },
  line: {
    main: theme.palette.line.main,
    light: theme.palette.line.light,
    dark: theme.palette.line.dark,
  },
  taboola: {
    main: theme.palette.taboola.main,
    light: theme.palette.taboola.light,
    dark: theme.palette.taboola.dark,
  }
}